import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const ProductTypes = (props: Props) => (
  <FilterAutocomplete
    label="Product Types"
    fieldName={'productTypes'}
    fieldPath={'documentInformation.productTypes'}
  />
)
